import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import ReactDom from 'react-dom';
import Radium from 'radium';
import {Snackbar} from 'rmwc';
import {push} from 'react-router-redux';
import {Checkbox} from 'rmwc';

import * as styles from '../../styles';
import Dialog from '../../dialog/dialog';
import {imageUrl} from '../../utilities/requests';
import {setSelectedItems} from '../tree/actions';
import {request} from '../../containers/actions';
import { ServerDate } from '../../containers/ServerDate';
import Tree from '../tree';
import Invoice from '../orders/invoice';
import { resizer1100, resizer600, resizer800 } from '../../responsiver';



class Payment extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    state = {saved: false}

    componentDidMount() {
        this.interval = setInterval(this.forceUpdate.bind(this), 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        if (this.state.connectingBank)
            return <Dialog isOpen={this.state.connectingBank}>
                <div>{window.gettext('Connecting to Bank')}...</div>
            </Dialog>;
        return <div> 
            <hr/>
            <div style={{float: 'right'}}>
                {window.gettext('Pay by Gateway')}:
                <br/>
                <button
                    style={{
                        ...styles.button,
                        marginBottom: '1em',
                        padding: '.1em',
                        minWidth: undefined,
                    }}
                    onClick={async () => {
                        this.setState({connectingBank: true});
                        let response;
                        try {
                            response = await this.context.store.dispatch(request({
                                path: `/order/${this.props.id}/pay_by_gateway/`,
                            }));
                        }
                        catch (exception) {
                            this.setState({connectingBank: false});
                            return;
                        }
                        // if (process.env.NODE_ENV !== 'production') {
                        //     window.location.reload();
                        //     return;
                        // } 
                        const form = document.createElement('form');
                                form.action = response.payment_id;
                                form.method = 'Get';
                                form.target = '_self';
                                const refId = document.createElement('input'); 
                                refId.value = response.payment_id; 
                                document.body.appendChild(form);
                                form.submit();
                    }}>
                    <img
                        src={imageUrl(window.images.mellat, {
                            width: 75,
                            type: 'contain',
                        })}
                    />
                </button>
            </div>
            <div style={{float: 'right', marginRight: '3em'}}>
                پرداخت از طریق کارت به کارت:
                <div style={{fontSize: '.9em'}}>
                    <br/>
                    شماره کارت: 6037997455803263<br/>
                    بانک ملی به نام حجت الله انصاری<br/>
                    شماره پیگیری درج شده در فیش پرداخت بانکی را در قسمت « شماره‌ی رسید بانکی » وارد کرده و دکمه «ارسال» را بزنید.
                </div>
            </div>
            <hr style={{clear: 'both'}}/>
            {window.gettext('Confirmation Number')}:
            <br/>
            <input
                key='confirmation_number_input'
                style={{...styles.field, width: '50%', float: 'right'}}
                value={(this.state.confirmation_number || '').persian()}
                onChange={({target: {value}}) =>
                    this.setState({confirmation_number: value.english()})
                }
            />
            <button
                style={{
                    ...styles.defaultButton,
                    marginBottom: '1em',
                    float: 'right',
                    // clear: 'right', 
                }}
                onClick={async () => {
                    if (!this.state.confirmation_number) {
                        alert(window.gettext('Incomplete data'));
                        return;
                    }
                    this.props.sendConfirmationNumber(this.state.confirmation_number);
                }}>
                {window.gettext('Send confirmation number')}
            </button>
            {_.includes([0, 1], this.props.payment_method) && this.props.status === 0
                ? <div style={{float: 'right', marginRight: '.5em'}}>
                    {window.gettext('Time Remaining')}:
                    &nbsp;
                    {(() => {
                        const remainingTime = (
                            (this.props.payment_method === 0 ? 24 : 48) * 3600 -
                                (ServerDate() - new Date(this.props.timestamp * 1000)) / 1000
                        ) - 20;
                        if (remainingTime >= 0)
                            return remainingTime.timerFormat();
                        else
                            return window.gettext('Timeout');
                    })()}
                </div>
                : null
            }
        </div>;
    }
}

//@Radium
export default class Order extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    state = {readAndDone: false}

    constructor(props, context) {
        super(props, context);
        this.sendConfirmationNumber = this.sendConfirmationNumber.bind(this);
    }

    componentDidMount() {
        this.fetch();
        this.interval = setInterval(this.forceUpdate.bind(this), 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.id !== this.props.id)
            this.fetch.bind(this)();
        if (prevState.status !== this.state.status) {
            this.context.store.dispatch(setSelectedItems(
                [this.state.status],
                'status',
                this.props.statusesTree.get('elementId'),
            ));
        }
    }

    async fetch() {
        if (!this.context.user) {
            setTimeout(this.fetch.bind(this), 500);
            return;
        }
        const response = await this.context.store.dispatch(request({
            path: `/${this.context.user.hasPerm('store.admin') || this.context.user.hasPerm('store.send')
                ? this.props.incomplete ? 'incomplete-order' : 'admin-order'
                : 'order'
            }/${this.props.id}/`,
        }));
        this.setState(response);
    }

    async sendConfirmationNumber(confirmationNumber) {
        this.setState(await this.context.store.dispatch(request({
            path:
            `/order/${this.props.id}/set_confirmation_number/`,
            body: {
                confirmation_number: confirmationNumber,
            },
            method: 'PATCH',
        })));
    }

    render() {
        const location = this.context.store.getState().getIn(['routing', 'locationBeforeTransitions']).toJS();
        if (this.state.id)
            return <div >
                <Snackbar
                    show={this.state.saved}
                    onClose={() => this.setState({saved: false})}
                    message={window.gettext('Saved changes!')}
                />
                <div style = {resizer1100}>
                <Dialog
                    easyCancel={false}
                    isOpen={location.query.first_visit}>
                    <span>
                        <div>
                            {window.interpolate(
                                window.gettext('Your order is registered with id %(order)s. You can trace it in orders menu.'),
                                {order: this.state.id.persian()},
                                true,
                            )}
                        </div>
                        {this.state.payment_method === 1
                            ? <div>
                                <br/>
                                <div style={{fontSize: '1.1em'}}>
                                    شماره کارت: 6037997455803263<br/>
                                    بانک ملی به نام حجت الله انصاری<br/>
                                </div>
                                <br/>
                                پس از پرداخت وجه، شماره پیگیری درج شده در فیش پرداخت بانکی را در قسمت « شماره‌ی رسید بانکی » وارد کرده و دکمه «ارسال» را بزنید.
                            </div>
                            : null
                        }
                        <div style={styles.dialogButtonContainer}>
                            <button
                                style={{
                                    ...styles.defaultDialogButton,
                                    marginTop: '1em',
                                }}
                                onClick={() => {
                                    const location = this.context.store.getState().getIn(['routing', 'locationBeforeTransitions']).toJS();
                                    this.context.store.dispatch(
                                        push({
                                            ...location,
                                            query: _.pickBy(location.query, key => key === 'first_visit'),
                                        }),
                                    );
                                    this.forceUpdate();
                                }}>
                                {window.gettext('OK')}
                            </button>
                        </div>
                    </span>
                    <span>{window.gettext('Order registered')}</span>
                </Dialog>
                <div
                    style={{
                        position: 'relative',
                        float: 'right',
                        width: '100%',
                        marginRight: '1em',
                        boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
                        borderRadius: '.2em',
                    }}>
                    <div style={{height: '35em', overflow: 'hidden'}}>
                        <div
                            style={{
                                float: 'right',
                                width: '75%',
                                display: 'flex',
                                height: '100%',
                                flexFlow: 'column',
                            }}>
                            <iframe
                                key='invoice-frame'
                                ref='invoice'
                                style={{width: '0', height: '0', border: 'none'}}
                                srcDoc={`<html>
    <head>
        <link rel="stylesheet" type="text/css" href="/css/mhelli.css">
        <style>
            body {
                font-family: IRANSans;
                font-size: .85rem;
            }
            @page {
                size: A5 Landscape;
                margin: 0;
            }
            @media print {
                html, body {
                    margin: 0;
                    width : 210mm;
                    height : 148mm
                    size: auto;
                }
                div {
                    -webkit-print-color-adjust: exact;
                }
            }
        </style>
    </head>
    <body><span id='invoice'><span>1</span><span style='font-weight: 700;'>2</span></span></body>
</html>`}
                            />
                            <div style={{flex: 1, paddingTop: '.5em', height: '22.5em'}}>
                                {this.props.incomplete
                                    ? <div style={{marginRight: '.5em'}}>
                                        {window.gettext('Status')}: {window.pgettext('Orders', 'Orders-Status-' + this.state.status)}
                                        <br/>
                                        {window.gettext('Tracking Code')}: {(this.state.tracking_code || '').persian()}
                                        <br/>
                                        {window.gettext('Confirmation Number')}: {(this.state.confirmation_number || '').persian()}
                                    </div>
                                    : this.context.user.hasPerm('store.admin')
                                        ? [
                                            (
                                                this.state.items.length > 0 &&
                                                !this.state.items[0].virtual &&
                                                (this.state.status === 2 || this.state.status === 3)
                                            )
                                                ? <button
                                                    key='invoice'
                                                    style={{
                                                        ...styles.defaultButton,
                                                        backgroundColor: styles.fourthColor,
                                                        marginBottom: '1em',
                                                        float: 'right',
                                                        marginLeft: '.5em',
                                                        marginRight: '.5em',
                                                    }}
                                                    onClick={() => {
                                                        const win = this.refs.invoice.contentWindow;
                                                        ReactDom.unmountComponentAtNode(
                                                            win.document.getElementById('invoice'),
                                                        );
                                                        ReactDom.render(
                                                            <span>
                                                                <Invoice {...this.state} loaded={() => win.print()}/>
                                                            </span>,
                                                            win.document.getElementById('invoice'),
                                                        );
                                                    }}>
                                                    {window.gettext('Print Invoice')}
                                                </button>
                                                : null,
                                            <div
                                                key='status'
                                                style={{
                                                    fontSize: '.9rem',
                                                    marginBottom: '1em',
                                                    width: 'calc(50% - 1em)',
                                                    float: 'right',
                                                    clear: 'right',
                                                    marginLeft: '.5em',
                                                    marginRight: '.5em',
                                                }}>
                                                <Tree
                                                    store={this.props.statusesTree}
                                                    readonly
                                                    header
                                                    multiSelection={false}
                                                    combobox
                                                    resource='status'
                                                    label={window.gettext('Status')}
                                                    staticItems={_.mapValues(
                                                        _.filter(
                                                            _.mapValues(Array(8), (__, index) => index),
                                                            status => (
                                                                this.context.user.hasPerm('store.change_paid_by_gateway_status') ||
                                                            this.state.status < 2 ||
                                                            !this.state.paid_virtual ||
                                                            status >= 2
                                                            ),
                                                        ),
                                                        index => ({id: index, label: window.pgettext('Orders', 'Orders-Status-' + index)}),
                                                    )}
                                                />
                                            </div>,
                                            <div
                                                key='note_for_sender'
                                                style={{
                                                    width: 'calc(50% - 1em)',
                                                    float: 'left',
                                                    clear: 'left',
                                                    marginLeft: '.5em',
                                                    marginRight: '.5em',
                                                }}>
                                                {window.gettext('Note for Sender')}:
                                                <textarea
                                                    key='note_for_sender_input'
                                                    style={{
                                                        ...styles.field,
                                                        width: '100%',
                                                        height: '8em',
                                                    }}
                                                    value={this.state.note_for_sender}
                                                    onChange={({target: {value}}) => this.setState({note_for_sender: value})}
                                                />
                                            </div>,
                                            <div
                                                key='tracking_code'
                                                style={{
                                                    width: 'calc(50% - 1em)',
                                                    float: 'right',
                                                    clear: 'right',
                                                    marginLeft: '.5em',
                                                    marginRight: '.5em',
                                                }}>
                                                {window.gettext('Tracking Code')}:
                                                <input
                                                    key='tracking_code_input'
                                                    style={{
                                                        ...styles.field,
                                                        width: '100%',
                                                    }}
                                                    value={(this.state.tracking_code || '').persian()}
                                                    onChange={({target: {value}}) =>
                                                        this.setState({tracking_code: value.english()})
                                                    }
                                                />
                                            </div>,
                                            <div
                                                key='confirmation_code'
                                                style={{
                                                    width: 'calc(50% - 1em)',
                                                    float: 'right',
                                                    clear: 'right',
                                                    marginLeft: '.5em',
                                                    marginRight: '.5em',
                                                }}>
                                                {window.gettext('Confirmation Number')}:
                                                <input
                                                    key='confirmation_number_input'
                                                    style={{
                                                        ...styles.field,
                                                        width: '100%',
                                                    }}
                                                    value={(this.state.confirmation_number || '').persian()}
                                                    onChange={({target: {value}}) => {
                                                        if (
                                                            this.context.user.hasPerm('store.change_paid_by_gateway_status') ||
                                                        this.state.status < 2 ||
                                                        !this.state.paid_virtual
                                                        )
                                                            this.setState({confirmation_number: value.english()});
                                                    }}
                                                />
                                            </div>,
                                            <button
                                                key='save'
                                                style={{
                                                    ...styles.defaultButton,
                                                    marginBottom: '1em',
                                                    float: 'right',
                                                    clear: 'right',
                                                    marginLeft: '.5em',
                                                    marginRight: '.5em',
                                                }}
                                                onClick={async () => {
                                                    await this.context.store.dispatch(request({
                                                        path: `/admin-order/${this.state.id}/`,
                                                        body: {
                                                            status: this.props.statusesTree.get('selected').keySeq().first(),
                                                            confirmation_number: this.state.confirmation_number || '',
                                                            tracking_code: this.state.tracking_code || '',
                                                            note_for_sender: this.state.note_for_sender,
                                                        },
                                                        method: 'PATCH',
                                                    }));
                                                    this.setState({saved: true});
                                                }}>
                                                {window.gettext('Save')}
                                            </button>,
                                            this.state.saved
                                                ? <div
                                                    key='saved'
                                                    style={{
                                                        float: 'right',
                                                        color: styles.successColor,
                                                        animation: 'x 2500ms ease-in 0s 1',
                                                        animationName: Radium.keyframes({
                                                            '0%': {opacity: '1'},
                                                            '100%': {opacity: '0'},
                                                        }),
                                                    }}>
                                                    {window.gettext('Saved changes!')}
                                                </div>
                                                : null,
                                            _.includes([0, 1], this.state.payment_method) && this.state.status === 0
                                                ? <div style={{float: 'right', marginRight: '.5em'}}>
                                                    {window.gettext('Time Remaining')}:
                                                &nbsp;
                                                    {(() => {
                                                        const remainingTime = (
                                                            (this.state.payment_method === 0 ? 24 : 48) * 3600 -
                                                        (ServerDate() - new Date(this.state.timestamp * 1000)) / 1000
                                                        ) - 20;
                                                        if (remainingTime >= 0)
                                                            return remainingTime.timerFormat();
                                                        else
                                                            return window.gettext('Timeout');
                                                    })()}
                                                </div>
                                                : null,
                                        ]
                                        : this.context.user.hasPerm('store.send')
                                            ? [
                                                <button
                                                    key='invoice'
                                                    style={{
                                                        ...styles.defaultButton,
                                                        backgroundColor: styles.fourthColor,
                                                        marginBottom: '1em',
                                                        float: 'right',
                                                        marginLeft: '.5em',
                                                        marginRight: '.5em',
                                                    }}
                                                    onClick={() => {
                                                        const win = this.refs.invoice.contentWindow;
                                                        ReactDom.unmountComponentAtNode(
                                                            win.document.getElementById('invoice'),
                                                        );
                                                        ReactDom.render(
                                                            <span>
                                                                <Invoice {...this.state} loaded={() => win.print()}/>
                                                            </span>,
                                                            win.document.getElementById('invoice'),
                                                        );
                                                    }}>
                                                    {window.gettext('Print Invoice')}
                                                </button>,
                                                this.state.note_for_sender
                                                    ? <div
                                                        key='note_for_sender'
                                                        style={{
                                                            width: 'calc(50% - 1em)',
                                                            float: 'left',
                                                            clear: 'left',
                                                            marginLeft: '.5em',
                                                            marginRight: '.5em',
                                                        }}>
                                                        {window.gettext('Note for Sender')}:
                                                        <div
                                                            style={{
                                                                border: '.0625em solid #9a9a9a',
                                                                padding: '.5em',
                                                                whiteSpace: 'pre',
                                                                height: '8em',
                                                                boxSizing: 'border-box',
                                                                overflow: 'scroll',
                                                            }}>
                                                            {this.state.note_for_sender}
                                                        </div>
                                                    </div>
                                                    : null,
                                                <div
                                                    key='tracking_code'
                                                    style={{
                                                        width: 'calc(50% - 1em)',
                                                        float: 'right',
                                                        clear: 'right',
                                                        marginLeft: '.5em',
                                                        marginRight: '.5em',
                                                    }}>
                                                    {window.gettext('Tracking Code')}:
                                                    <input
                                                        key='tracking_code_input'
                                                        style={{
                                                            ...styles.field,
                                                            width: '100%',
                                                        }}
                                                        value={(this.state.tracking_code || '').persian()}
                                                        onChange={({target: {value}}) =>
                                                            this.setState({tracking_code: value.english()})
                                                        }
                                                    />
                                                </div>,
                                                <button
                                                    key='mark_sent'
                                                    style={{
                                                        ...styles.defaultButton,
                                                        marginBottom: '1em',
                                                        float: 'right',
                                                        clear: 'right',
                                                        marginLeft: '.5em',
                                                        marginRight: '.5em',
                                                        cursor: (
                                                            this.state.tracking_code || '').length !== 0 &&
                                                            (this.state.readAndDone || !this.state.note_for_sender)
                                                            ? 'pointer'
                                                            : 'not-allowed',
                                                        backgroundColor: (
                                                            this.state.tracking_code || '').length !== 0 &&
                                                            (this.state.readAndDone || !this.state.note_for_sender)
                                                            ? styles.defaultButton.backgroundColor
                                                            : undefined,
                                                        color: (
                                                            this.state.tracking_code || '').length !== 0 &&
                                                            (this.state.readAndDone || !this.state.note_for_sender)
                                                            ? styles.defaultButton.color
                                                            : 'black',
                                                    }}
                                                    disabled={(
                                                        (this.state.tracking_code || '').length === 0 ||
                                                        (!this.state.readAndDone && this.state.note_for_sender)
                                                    )}
                                                    onClick={async () => {
                                                        await this.context.store.dispatch(request({
                                                            path: `/admin-order/${this.state.id}/`,
                                                            body: {
                                                                status: 4,
                                                                tracking_code: this.state.tracking_code || '',
                                                            },
                                                            method: 'PATCH',
                                                        }));
                                                        const path = this.context.store.getState().getIn(
                                                            ['routing', 'locationBeforeTransitions', 'pathname'],
                                                        );
                                                        this.context.store.dispatch(push(path.split('/').slice(0, -2).join('/') + '/'));
                                                    }}>
                                                    {window.gettext('Mark Sent')}
                                                </button>,
                                                this.state.note_for_sender
                                                    ? <div
                                                        key='confirm_requirements'
                                                        style={{
                                                            width: 'calc(50% - 1em)',
                                                            float: 'left',
                                                            clear: 'left',
                                                            marginLeft: '.5em',
                                                            marginRight: '.5em',
                                                        }}>
                                                        <Checkbox
                                                            value={this.state.readAndDone}
                                                            onChange={({target: {checked}}) => this.setState({readAndDone: checked})}>
                                                            &nbsp;
                                                            {window.gettext('Read and done!')}
                                                        </Checkbox>
                                                    </div>
                                                    : null,
                                            ]
                                            : <div
                                                style={{
                                                    marginLeft: '.5em',
                                                    marginRight: '.5em',
                                                }}>
                                                {window.gettext('Status')}: {window.pgettext('Orders-', 'Orders-Status-' + this.state.status)}
                                                {_.includes([0, 1], this.state.status)
                                                    ? <Payment
                                                        {...this.state}
                                                        sendConfirmationNumber={this.sendConfirmationNumber}
                                                    />
                                                    : this.state.status === 4
                                                        ? <div>
                                                            {window.gettext('Tracking Code')}:&nbsp;
                                                            <input
                                                                style={{fontSize: '1em'}}
                                                                readOnly
                                                                value={this.state.tracking_code.persian()}
                                                                onKeyDown={({target}) => target.select()}
                                                                onKeyUp={({target}) => target.select()}
                                                                onClick={({target}) => target.select()}
                                                                onCopy={async ({target}) => {
                                                                    target.value = this.state.tracking_code;
                                                                    target.select();
                                                                    await window.wait();
                                                                    target.value = this.state.tracking_code.persian();
                                                                    target.select();
                                                                }}
                                                                onCut={async ({target}) => {
                                                                    target.value = this.state.tracking_code;
                                                                    target.select();
                                                                    await window.wait();
                                                                    target.value = this.state.tracking_code.persian();
                                                                    target.select();
                                                                }}
                                                            />
                                                            <br/>
                                                            {window.gettext('Tracking your shipment in Post website')}:
                                                            <br/>
                                                            <br/>
                                                            <a
                                                                href='http://newtracking.post.ir/Search.aspx'
                                                                rel='noreferrer noopener'
                                                                target='_blank'
                                                                style={{
                                                                    ...styles.button,
                                                                    display: 'inline-block',
                                                                    minWidth: undefined,
                                                                    textAlign: 'center',
                                                                    fontSize: '.9em',
                                                                    padding: '.5em .1em .5em',
                                                                    textDecoration: 'none',
                                                                }}>
                                                                <img
                                                                    src={imageUrl(window.images.post, {
                                                                        height: 45,
                                                                        type: 'contain',
                                                                    })}
                                                                />
                                                                <div style={{maxWidth: '7.5em', fontSize: '.75em'}}>
                                                                    {window.gettext('Shipment Tracing System')}
                                                                </div>
                                                            </a>
                                                            {/* <iframe */}
                                                            {/*     style={{ */}
                                                            {/*         width: 'calc(100% / .9)', */}
                                                            {/*         height: 'calc(18.5em / .9)', */}
                                                            {/*         border: '.0625em solid #9a9a9a', */}
                                                            {/*         padding: '.5em', */}
                                                            {/*         boxSizing: 'border-box', */}
                                                            {/*         transform: 'scale(.9)', */}
                                                            {/*         transformOrigin: 'right top', */}
                                                            {/*     }} */}
                                                            {/*     src='http://newtracking.post.ir/Search.aspx' */}
                                                            {/* /> */}
                                                        </div>
                                                        : null
                                                }
                                            </div>
                                }
                            </div>
                            <div style={{borderTop: '.125em solid #cacaca'}}>
                                <div
                                    style={{
                                        float: 'right',
                                        width: '65%',
                                        borderLeft: '.125em solid #cacaca',
                                        boxSizing: 'border-box',
                                    }}>
                                    <div
                                        style={{
                                            marginRight: '.5em',
                                            marginTop: '.5em',
                                            marginBottom: '-.25em',
                                            fontSize: '1.1em',
                                            position: 'relative',
                                        }}>
                                        {this.state.items[0].virtual? 'اطلاعات تکمیلی' : window.gettext('Recipient Info')}
                                        <i
                                            style={{
                                                position: 'absolute',
                                                left: '20%',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                            }}
                                            className='fa-envelope-o fa-lg'>
                                        </i>
                                    </div>
                                    <hr style={{borderTop: '.125em solid #cacaca', width: '80%', marginRight: '0'}}/>
                                    <div style={{margin: '.5em'}}>
                                        <span style={{color: '#9a9a9a'}}>{window.gettext('Firstname')}:</span>&nbsp;
                                        <span style={{color: '#2a2a2a'}}>
                                            {(this.state.firstname || '').persian()}&nbsp;
                                            {(this.state.lastname || '').persian()}
                                        </span>
                                        <br/>
                                        <span style={{color: '#9a9a9a'}}>{window.gettext('Contact Info')}:</span>&nbsp;
                                        <span style={{color: '#2a2a2a'}}>
                                            {(this.state.cell_phone || '').persian()}{window.gettext(',')}&nbsp;
                                            {(this.state.phone || '').persian()}
                                        </span>
                                        <br/>
                                        <span style={{color: '#9a9a9a'}}>{window.gettext('Postal Code')}:</span>&nbsp;
                                        <span style={{color: '#2a2a2a'}}>{(this.state.postal_code || '-').persian()}</span>
                                        <br/>
                                        <div style={{height: '3em'}}>
                                            <span style={{color: '#9a9a9a'}}>{!this.state.items[0].virtual?window.gettext('Address') :'مدرسه' }:</span>&nbsp;
                                            <span style={{color: '#2a2a2a'}}>
                                                {(this.state.region_display || '-').persian()} -&nbsp;
                                                {(this.state.city_display || '-').persian()} -&nbsp;
                                                {(this.state.address || '-').persian()}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                {this.state.delivery_method !== null
                                    ? <div style={{float: 'right', width: '35%'}}>
                                    <div
                                        style={{
                                            marginRight: '.5em',
                                            marginTop: '.5em',
                                            marginBottom: '-.25em',
                                            fontSize: '1.1em',
                                            position: 'relative',
                                        }}>
                                        {window.gettext('Delivery Method')}
                                        <i
                                            style={{
                                                position: 'absolute',
                                                left: '20%',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                            }}
                                            className='fa-truck fa-lg'>
                                        </i>
                                    </div>
                                    <hr style={{borderTop: '.125em solid #cacaca', width: '80%', marginRight: '0'}}/>
                                    <div style={{margin: '.5em'}}>
                                        {this.state.delivery_method !== null
                                            ? <span>
                                                {{
                                                    0: window.gettext('Bespoke Post'),
                                                    1: window.gettext('Pishtaz Post'),
                                                    2: window.gettext('Transportation'),
                                                    3: window.gettext('Terminal'),
                                                }[this.state.delivery_method]}
                                                &nbsp;-&nbsp;
                                                <span style={{fontWeight: '700'}}>
                                                    {(this.state.delivery_price
                                                        ? this.state.delivery_price.persian() + ' ' + window.gettext('Tooman')
                                                        : window.gettext('Free')
                                                    )}
                                                </span>
                                            </span>
                                            : '-'
                                        }
                                    </div>
                                </div>:null
                                }
                               
                                <div style={{float: 'right', width: '35%'}}>
                                    <div
                                        style={{
                                            marginRight: '.5em',
                                            marginTop: '.5em',
                                            marginBottom: '-.25em',
                                            fontSize: '1.1em',
                                            position: 'relative',
                                        }}>
                                        {window.gettext('Payment Method')}
                                        <i
                                            style={{
                                                position: 'absolute',
                                                left: '20%',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                            }}
                                            className='fa-credit-card fa-lg'>
                                        </i>
                                    </div>
                                    <hr style={{borderTop: '.125em solid #cacaca', width: '80%', marginRight: '0'}}/>
                                    <div style={{margin: '.5em'}}>
                                        {this.state.payment_method !== null
                                            ? <span>
                                                {{
                                                    0: window.gettext('Bank gateway'),
                                                    1: window.gettext('Draft'),
                                                    2: window.gettext('No Payment / Free'),
                                                    3: window.gettext('Debtor'),
                                                }[this.state.payment_method]}
                                                &nbsp;-&nbsp;
                                                <span style={{fontWeight: '700'}}>
                                                    {this.state.price.persian()  + ' ' + window.gettext('Tooman')}
                                                </span>
                                            </span>
                                            : '-'
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            style={{
                                float: 'right',
                                width: '25%',
                                height: '100%',
                                borderRight: '.125em solid #cacaca',
                                boxSizing: 'border-box',
                                position: 'relatve',
                            }}>
                            <div
                                style={{
                                    marginRight: '.5em',
                                    marginTop: '.5em',
                                    marginBottom: '-.25em',
                                    fontSize: '1.1em',
                                    position: 'relative',
                                }}>
                                {window.gettext('Cart')}
                                <i
                                    style={{
                                        position: 'absolute',
                                        left: '20%',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                    }}
                                    className='fa-shopping-basket fa-lg'>
                                </i>
                            </div>
                            <hr style={{borderTop: '.125em solid #cacaca', width: '80%', marginRight: '0'}}/>
                            <div style={{padding: '.5em', maxHeight: 'calc(100% - 10em)', overflowY: 'auto'}}>
                                {_.map(
                                    _.sortBy(this.state.items, 'timestamp'),
                                    (item, index) => [
                                        <div
                                            ref={item.type + ':' + item.id}
                                            key={item.type + ':' + item.id}
                                            style={{
                                                overflow: 'hidden',
                                                padding: '.5em',
                                                ...((Date.now() - item.editTimestamp) < 1200
                                                    ? {backgroundColor: 'rgb(100, 210, 100)'}
                                                    : {}
                                                ),
                                            }}>
                                                {/* عکس داخل سبد خرید */}
                                            <img
                                                style={{
                                                    width: '3em',
                                                    height: '4em',
                                                    verticalAlign: 'top',
                                                    marginRight: '.5em',
                                                    marginLeft: '.5em',
                                                    float: 'right',
                                                }}
                                                src={imageUrl(item.final_image, {
                                                    width: 48,
                                                    height: 64,
                                                    type: 'cover',
                                                })}
                                            />
                                            <div style={{float: 'right', fontSize: '.9em', width: 'calc(100% - 4.75em/.9)'}}>
                                                <div style={{width: '100%', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                                                    {item.caption}
                                                </div>
                                                <div style={{fontSize: '.85em'}}>
                                                    {window.gettext('Count')}: {item.count.persian()}
                                                </div>
                                                <div style={{fontSize: '.85em'}}>
                                                    {window.gettext('Price')}:&nbsp;
                                                    {(item.price ? item.price * item.count : '-').persian()} {window.gettext('Tooman')}
                                                </div>
                                            </div>
                                        </div>,
                                        index < _.size(this.state.items) - 1
                                            ? <hr style={{width: '14em', marginRight: '0'}}/>
                                            : null,
                                    ]
                                )}
                            </div>
                            <div style={{position: 'absolute', bottom: '0'}}>
                                <div style={{padding: '.5em'}}>
                                    {window.gettext('Total Price')}:&nbsp;
                                    <span style={{fontWeight: '800'}}>
                                        {_.reduce(
                                            this.state.items,
                                            (sum, item) => sum + item.price * item.count,
                                            0,
                                        ).persian()} {window.gettext('Tooman')}
                                    </span>
                                    &nbsp;
                                    <span style={{fontSize: '.8em'}}>
                                        ({_.reduce(
                                            this.state.items,
                                            (sum, item) => sum + item.count,
                                            0,
                                        ).persian()} {window.pgettext('cart', 'Items')})
                                    </span>
                                </div>
                                {
                                    this.state.weight != 0  
                                    ?<div style={{padding: '.5em'}}>
                                    {window.gettext('Total Weight')}:&nbsp;
                                    <span style={{fontWeight: '800'}}>
                                        {this.state.weight.persian()} {window.gettext('KG')}
                                    </span>
                                </div>:null
                                }
                            </div>
                        </div>
                    </div>
                </div>
            

                </div>
            </div>;
        return null;
    }
}
